<template>
    <div class="tips" v-show="tipsInfo" @click="hideTips">
        <p class="tips__info">{{ tipsInfo }}</p>
    </div>
</template>
<script>
export default {
    name:'tips',
    data(){
        return{
            tipsInfo:null
        }
    },
    created(){
        this.$tips.$on('tips',(data)=>{
            this.tipsInfo = data
        })
    },
    methods:{
        hideTips(){
            this.tipsInfo = null
        }
    },
    watch:{
        tipsInfo:function(){
            if(this.tipsInfo){
                setTimeout(()=>{
                    this.hideTips()
                },1500)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .tips{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba($color: #000000, $alpha: 0.85);
        z-index: 9;
        &__info{
            position: absolute;
            left: 50%;
            top: 40%;
            transform: translateX(-50%) translateY(-50%);
            background-color: #fff;
            padding: .2rem .4rem;
            box-sizing: border-box;
            height: auto;
            border-radius: .04rem;
            text-align: left;
            font-size: .3rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/tips.vue